"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedGraphQlErrorHasErrorCode = exports.extendedApolloErrorHasErrorCode = exports.hasStandardErrorCode = exports.hasErrorCode = exports.getStandardErrors = exports.getExtendedErrors = void 0;
const interfaces_1 = require("./interfaces");
/**
 * Extracts errors from an error object.
 *
 * @param error An error object that should be an ApolloError or GraphQlError
 * @param schema The schema of the anticipated errors.
 */
const getExtendedErrors = (error, schema) => {
    const parsedApolloError = (0, interfaces_1.safeParseExtendedApolloError)(error, schema);
    if (parsedApolloError.success) {
        return parsedApolloError.data.graphQLErrors.flatMap((graphQlError) => graphQlError.extensions.errors);
    }
    const parsedGraphQlError = (0, interfaces_1.safeParseExtendedGraphQlError)(error, schema);
    if (parsedGraphQlError.success) {
        return parsedGraphQlError.data.extensions.errors;
    }
    // Log the error and re-throw it. Let consumer determine how to handle it since it can't be parsed.
    console.error(error);
    throw error;
};
exports.getExtendedErrors = getExtendedErrors;
const getStandardErrors = (error) => (0, exports.getExtendedErrors)(error, interfaces_1.StandardErrorSchema);
exports.getStandardErrors = getStandardErrors;
/**
 * Parses the error and checks if it has a specific error code.
 */
const hasErrorCode = (error, errorCode, schema) => {
    const parsedApolloError = (0, interfaces_1.safeParseExtendedApolloError)(error, schema);
    if (parsedApolloError.success) {
        return (0, exports.extendedApolloErrorHasErrorCode)(parsedApolloError.data, errorCode);
    }
    const parsedGraphQlError = (0, interfaces_1.safeParseExtendedGraphQlError)(error, schema);
    if (parsedGraphQlError.success) {
        return (0, exports.extendedGraphQlErrorHasErrorCode)(parsedGraphQlError.data, errorCode);
    }
    return false;
};
exports.hasErrorCode = hasErrorCode;
/**
 * Parses the error and checks if it has a StandardError code.
 */
const hasStandardErrorCode = (error, errorCode) => (0, exports.hasErrorCode)(error, errorCode, interfaces_1.StandardErrorSchema);
exports.hasStandardErrorCode = hasStandardErrorCode;
/**
 * Accepts a previously parsed error and checks if it has a specific error code.
 */
const extendedApolloErrorHasErrorCode = (extendedApolloError, errorCode) => extendedApolloError.graphQLErrors.some((graphQlError) => graphQlError.extensions.errors.some((error) => error.code === errorCode));
exports.extendedApolloErrorHasErrorCode = extendedApolloErrorHasErrorCode;
/**
 * Accepts a previously parsed error and checks if it has a specific error code.
 */
const extendedGraphQlErrorHasErrorCode = (extendedGraphQlError, errorCode) => extendedGraphQlError.extensions.errors.some((error) => error.code === errorCode);
exports.extendedGraphQlErrorHasErrorCode = extendedGraphQlErrorHasErrorCode;
